﻿<div
    class="sidepanel-overlay"
    *ngIf="isVisible"
    (click)="$event.stopPropagation()">
</div>

<div id="sidebar" class="sidebar" [class.visible]="isVisible">
    <div class="header-container">
        <h2>{{caption}}</h2>
    </div>

    <div class="content-container">
        <ng-content></ng-content>
    </div>

    <div class="button-container">
        <button
            type="submit"
            class="button-save"
            (click)="triggerDone()">
            Save <i class="fas fa-save"></i>
        </button>
        <button
            type="submit"
            class="button-cancel"
            (click)="triggerCancel()">
            Cancel
        </button>
    </div>
</div>